/* Copyright (c) 2026 - Svayam Infoware Pvt. Ltd. All rights reserved. */
/** Browser storage helpers for Ask AI — kept separate to avoid Auth ↔ Chat circular imports. */

export const ASK_AI_SESSION_KEY_LEGACY = 'askAi.chatSessionId';
export const ASK_AI_TURNS_KEY_LEGACY = 'askAi.chatTurns';

/** Wipe legacy global keys + every per-user Ask AI key (logout / account switch). */
export function clearAllAskAiBrowserStorage(): void {
  try {
    localStorage.removeItem(ASK_AI_SESSION_KEY_LEGACY);
    localStorage.removeItem(ASK_AI_TURNS_KEY_LEGACY);
    sessionStorage.removeItem(ASK_AI_SESSION_KEY_LEGACY);
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && (k.startsWith('askAi.chatSessionId') || k.startsWith('askAi.chatTurns'))) {
        toRemove.push(k);
      }
    }
    for (const k of toRemove) localStorage.removeItem(k);
  } catch {
    /* private mode */
  }
}

export function sessionKeyForUser(userKey: string): string {
  return `askAi.chatSessionId.u:${userKey}`;
}

export function turnsKeyForUser(userKey: string): string {
  return `askAi.chatTurns.u:${userKey}`;
}
